module.exports = __webpack_public_path__ + "static/media/19.095f3df8.JPG";